<script>import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let type = 'rotate';
export let loading = undefined;
export let swapped = undefined;
const defaultClass = 'swap relative inset-0 stwui-swap';
const rotateClass = 'swap-rotate';
const flipClass = 'swap-flip';
$: finalClass = twMerge(defaultClass, type === 'rotate' ? rotateClass : false, type === 'flip' ? flipClass : false, $$props.class);
</script>

<div
	class={finalClass}
	use:useActions={use}
	use:forwardEvents
	{...exclude($$props, ['use', 'class'])}
>
	<input type="checkbox" class="invisible" checked={loading || swapped} disabled />
	<span class="swap-on absolute inset-0">
		<slot name="on" />
	</span>
	<span class="swap-off absolute inset-0 {loading || swapped ? 'isOn' : 'isOff'}">
		<slot name="off" />
	</span>
</div>

<style>
	.swap {
		cursor: pointer;
}

	.swap > * {
		transform-origin: center;
		transition-duration: 300ms;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
		transition-property: transform, opacity;
}

	.swap-rotate .swap-on {
		--tw-rotate: 0deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		display: flex;
		justify-content: center;
		align-items: center;
}

	.swap-rotate .swap-off {
		--tw-rotate: -45deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
}

	.swap-rotate input:checked ~ .swap-off {
		--tw-rotate: 0deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		opacity: 1;
}

	.swap-rotate input:checked ~ .swap-on {
		opacity: 0;
		--tw-rotate: 45deg;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

	.swap-flip {
		transform-origin: center;
		transform-style: preserve-3d;
		perspective: 16em;
}

	.swap-flip .swap-on {
		transform: rotateY(0deg);
		backface-visibility: hidden;
		opacity: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.swap-flip .swap-off {
		transform: rotateY(-180deg);
		backface-visibility: hidden;
		opacity: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.swap-flip input:checked ~ .swap-off {
		transform: rotateY(0deg);
		opacity: 1;
	}

	.swap-flip input:checked ~ .swap-on {
		transform: rotateY(180deg);
		opacity: 0;
	}
</style>
